import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";
import { Button } from "@circleco/compass/components/Button";

import { t } from "@/i18n-js/instance";

import { useUpgradePlanContext } from "./../UpgradePlanContext";
import { UpgradePlanModalBody } from "./../UpgradePlanModalBody";
import { UpgradePlanModalFooter } from "./../UpgradePlanModalFooter";
import { UpgradePlanModalHeader } from "./../UpgradePlanModalHeader";
import { getDisplayName, getDisplaySubheading } from "./helpers";
import { PlanLineItems } from "./PlanLineItems";

const i18nRoot = "pricing_plans.upgrade_modal";

interface UpgradeIntervalDetailsProps {
  hideModal: () => void;
  onSubmitHandler: () => void;
  subheading?: string;
}

export const UpgradeIntervalDetails = ({
  subheading = "",
  hideModal,
  onSubmitHandler,
}: UpgradeIntervalDetailsProps) => {
  const { plan, emailHubPlan, isEmailHubOnlyUpgrade } = useUpgradePlanContext();

  const displayName = getDisplayName(plan, emailHubPlan);

  const displaySubheading = getDisplaySubheading(
    subheading,
    isEmailHubOnlyUpgrade,
  );

  return (
    <>
      <UpgradePlanModalHeader
        title={t([i18nRoot, "interval_upgrade_title"], { plan: displayName })}
      >
        <Modal.Title>
          {t([i18nRoot, "interval_upgrade_title"], {
            plan: displayName,
          })}
        </Modal.Title>

        <Modal.HeaderActions>
          <Modal.CloseButton onClick={hideModal} />
        </Modal.HeaderActions>
      </UpgradePlanModalHeader>
      <UpgradePlanModalBody>
        {displaySubheading && (
          <div className="mb-6">
            <Typography.BodyMd color="text-default">
              {displaySubheading}
            </Typography.BodyMd>
          </div>
        )}

        <div className="mb-6">
          <Typography.LabelMd weight="semibold" size="text-md">
            {t([i18nRoot, "interval_switch.upgrade.cta"])}
            <span className="text-green-success">
              {t(`${i18nRoot}.interval_switch.upgrade.savings`, {
                savings: plan?.annual_discount_amount_with_currency,
              })}
            </span>
          </Typography.LabelMd>

          <Typography.BodySm weight="normal" size="text-sm">
            {t([i18nRoot, "interval_switch.upgrade.cta_subheading"])}
          </Typography.BodySm>
        </div>

        <PlanLineItems />
      </UpgradePlanModalBody>
      <UpgradePlanModalFooter
        className="mt-5"
        layout="full-width"
        primaryAction={{
          label: t([i18nRoot, "actions.interval_upgrade"], {
            plan: displayName,
          }),
          onClick: onSubmitHandler,
        }}
      >
        <Button variant="primary" size="lg" fullWidth onClick={onSubmitHandler}>
          {t([i18nRoot, "actions.interval_upgrade"], { plan: displayName })}
        </Button>
      </UpgradePlanModalFooter>
    </>
  );
};
